import { App } from "vue";
import { AuthControl } from "../authControl";

import { RoadtripsServiceImpl } from "./roadtripsService";
import { StopsServiceImpl } from "./stopsService";
import { ProfilesServiceImpl } from "./profilesService";
import { InterestsServiceImpl } from "./interestsService";
import { StopTemplatesServiceImpl } from "./stopTemplatesService";
import { ReferralsServiceImpl } from "./referralsService";
import { AffiliatesServiceImpl } from "./affiliatesService";
import { TimezonesServiceImpl } from "./timezonesService";
import { EventsServiceImpl } from "./eventsService";
import { AdsServiceImpl } from "./adsService";
import { AlertsServiceImpl } from "./alertsService";


import { AdminAdsServiceImpl } from "./adminAdsService";
import { AdminProfilesServiceImpl } from "./adminProfilesService";
import { AdminUsersServiceImpl } from "./adminUsersService";
import { AdminOperationsServiceImpl } from "./adminOperationsService";
import { AdminRoadtripsServiceImpl } from "./adminRoadtripsService";
import { AdminOpenAIAssistantsServiceImpl } from "./adminOpenAIAssistantsService";
import { AdminActionsServiceImpl } from "./adminActionsService";
import { ActionsServiceImpl } from "./actionsService";



export function provideServices(app: App, apiServer: string, authControl: AuthControl) {
  
  const roadtripsService = new RoadtripsServiceImpl(
    apiServer,
    authControl,
  );

  const stopsService = new StopsServiceImpl(
    apiServer,
    authControl
  );

  const profilesService = new ProfilesServiceImpl(
    apiServer,
    authControl
  );

  const interestsService = new InterestsServiceImpl(
    apiServer,
    authControl
  );

  const stopTemplatesService = new StopTemplatesServiceImpl();

  const referralsService = new ReferralsServiceImpl(
    apiServer, 
    authControl
  );

  const affiliatesService = new AffiliatesServiceImpl(
    apiServer, 
    authControl
  );

  const timezonesService = new TimezonesServiceImpl(
    apiServer
  );

  const eventsService = new EventsServiceImpl(
    apiServer,
    authControl
  );

  const adsService = new AdsServiceImpl(
    apiServer,
    authControl
  );

  const actionsService = new ActionsServiceImpl(
    apiServer,
    authControl
  );

  const alertsService = new AlertsServiceImpl(
    apiServer,
    authControl
  )

  app.provide('profilesService', profilesService)
  app.provide('roadtripsService', roadtripsService);
  app.provide('stopsService', stopsService);
  app.provide('interestsService', interestsService);
  app.provide('stopTemplatesService', stopTemplatesService);
  app.provide('referralsService', referralsService);
  app.provide('affiliatesService', affiliatesService);
  app.provide('timezonesService', timezonesService);
  app.provide('eventsService', eventsService);
  app.provide('adsService', adsService);
  app.provide('actionsService', actionsService);
  app.provide('alertsService', alertsService);

}

export function provideAdminServices(app: App, apiServer: string, authControl: AuthControl) {
  

  const adminActionsService = new AdminActionsServiceImpl(
    apiServer,
    authControl
  );

  const adminAdsService = new AdminAdsServiceImpl(
    apiServer,
    authControl
  );

  const adminProfilesService = new AdminProfilesServiceImpl(
    apiServer,
    authControl
  );

  const adminUsersService = new AdminUsersServiceImpl(
    apiServer,
    authControl
  );

  const adminOperationsService = new AdminOperationsServiceImpl(
    apiServer,
    authControl
  );

  const adminRoadtripsService = new AdminRoadtripsServiceImpl(
    apiServer,
    authControl
  );

  const adminOpenAIAssistantsService = new AdminOpenAIAssistantsServiceImpl(
    apiServer,
    authControl
  );


  app.provide('adminActionsService', adminActionsService);
  app.provide('adminAdsService', adminAdsService);
  app.provide('adminProfilesService', adminProfilesService);
  app.provide('adminUsersService', adminUsersService);
  app.provide('adminOperationsService', adminOperationsService);
  app.provide('adminRoadtripsService', adminRoadtripsService);
  app.provide('adminOpenAIAssistantsService', adminOpenAIAssistantsService);


}

export type { RoadtripsService } from "./roadtripsService";
export type { StopsService } from "./stopsService";
export type { ProfilesService } from "./profilesService";
export type { InterestsService } from "./interestsService";
export type { StopTemplatesService } from "./stopTemplatesService";
export type { ReferralsService } from "./referralsService";
export type { AffiliatesService } from "./affiliatesService";
export type { TimezonesService } from "./timezonesService";
export type { EventsService } from "./eventsService";
export type { AdsService } from "./adsService";
export type { ActionsService } from "./actionsService";

export type { AdminAdsService } from "./adminAdsService";
export type { AdminProfilesService } from "./adminProfilesService";
export type { AdminUsersService } from "./adminUsersService";
export type { AdminOperationsService } from "./adminOperationsService";
export type { AdminRoadtripsService } from "./adminRoadtripsService";
export type { AdminOpenAIAssistantsService } from "./adminOpenAIAssistantsService";
export type { AdminActionsService } from "./adminActionsService";
